<!--
 * @Author: Haoxiwei 1078734933@qq.com
 * @Date: 2022-03-11 14:30:38
 * @LastEditors: Haoxiwei 1078734933@qq.com
 * @LastEditTime: 2024-03-25 17:04:45
 * @FilePath: /wemeet-iam/Users/hvv/weMeetSpace/WeMeet_admin_project/wemeet-admin/src/views/dragger/template/tpl-tab.vue
 * @Description: 
 * Copyright (c) 2024 by WeMeet, All Rights Reserved. 
-->
<template>
  <div>
    <div class="layout">
      <div class="tabBox">
        <div class="tab no-scroll">
          <template v-for="(item, index) in res.list" :key="index">
            <div
              class="tabItem"
              :class="[activeName == index ? 'check' : '']"
              :style="{
                background:
                  activeName == index
                    ? attr.hasOwnProperty('attributeParams')
                      ? attr.attributeParams.background
                      : '#00c4c9'
                    : '#fff',
              }"
              @click="changeTab(index)"
            >
              {{ item.title }}
            </div>
          </template>
        </div>
        <template v-for="(item, index) in res.list" :key="index">
          <div v-if="activeName == index" class="itemBox">
            <div v-if="item.link.length > 0">
              <template v-for="(sItem, sIndex) in item.link" :key="sIndex">
                <tpl-shop v-if="sItem.type == 'shop'" :res="sItem" />
                <tpl-active v-if="sItem.type == 'active'" :res="sItem" />
                <tpl-article v-if="sItem.type == 'Article'" :res="sItem" />

                <tpl-page v-if="sItem.type == 'page'" :res="sItem" />
                <tpl-exhibition v-if="sItem.type == 'exhibition'" :res="sItem" />
                <tpl-holdMeet v-if="sItem.type == 'holdMeet'" :res="sItem" />
              </template>
            </div>

            <div v-else style="text-align: center">
              <img
                alt=""
                src="https://wemeet-1302608036.cos.ap-shanghai.myqcloud.com/MEHZ/images/noContent.png"
                style="width: 100px; height: 100px"
              />
              <p>暂无数据</p>
            </div>
          </div>
        </template>
      </div>
    </div>
  </div>
</template>

<script>
  import { defineComponent, getCurrentInstance, onMounted, reactive, toRefs } from 'vue'
  import tplShop from './tpl_shop'
  import tplActive from './tpl_active'
  import tplArticle from './tpl_article'
  import tplPage from './tpl_page'
  import tplExhibition from './tpl_exhibition'
  import tplHoldMeet from './tpl_holdMeet'
  export default defineComponent({
    name: 'TplGrid',
    components: {
      tplShop,
      tplActive,
      tplArticle,
      tplPage,
      tplExhibition,
      tplHoldMeet,
    },
    props: {
      res: Object,
      attr: Object,
    },
    setup(props) {
      const state = reactive({
        activeName: 0,
      })

      const changeTab = (index) => {
        state.activeName = index
      }

      return {
        ...toRefs(state),
        changeTab,
      }
    },
  })
</script>
<style lang="scss" scoped>
  @import './tpl.scss';
  .no-scroll::-webkit-scrollbar {
    display: none;
  }
  .tab {
    width: 100%;
    height: 40px;
    background: #e6e6e6;
    display: flex;
    justify-content: left;
    overflow-x: auto;
    overflow-y: hidden;
    .tabItem {
      min-width: 70px;
      height: 100%;
      text-align: center;
      line-height: 40px;
      font-size: 14px;
      font-weight: 500;
      color: #666666;
      border-radius: 5px;
      &.check {
        background: #00c4c9;
        font-size: 16px;
        font-weight: 700;
        color: #ffffff;
      }
    }
  }
  .itemBox {
    margin-top: 20px;
    min-height: 200px;
  }
</style>
